<template>
  <q-dialog v-model="currentVisible" content-class="dialog-edit-dashboard" @hide="resetEditDialog">
    <q-layout
      view="hHh Lpr lff"
      container
      :style="{ height: '400px', maxWidth: '800px' }"
      class="shadow-2 rounded-borders"
    >
      <q-header class="bg-primary">
        <q-toolbar>
          <q-btn flat @click="drawer = !drawer" round icon="menu"></q-btn>
          <q-toolbar-title
            >{{ $t('Edit') }}: {{ currentDashboard && currentDashboard.name }}</q-toolbar-title
          >
          <q-btn flat v-close-popup round dense icon="close"></q-btn>
        </q-toolbar>
      </q-header>

      <q-drawer
        v-model="drawer"
        show-if-above
        :width="200"
        :breakpoint="500"
        bordered
        content-class="bg-white"
      >
        <q-scroll-area class="fit">
          <q-list>
            <template v-for="(menuItem, index) in menuList">
              <q-item
                :key="index"
                clickable
                :active="menuItem.label === activeMenuItem"
                @click="setActiveMenuItem(menuItem.label)"
                v-ripple
              >
                <q-item-section avatar>
                  <q-icon :name="menuItem.icon"></q-icon>
                </q-item-section>
                <q-item-section>
                  {{ $t(menuItem.label) }}
                </q-item-section>
              </q-item>
              <q-separator :key="'sep' + index" v-if="menuItem.separator"></q-separator>
            </template>
          </q-list>
        </q-scroll-area>
      </q-drawer>

      <q-page-container class="bg-content">
        <q-page padding>
          <template v-if="activeMenuItem === 'Settings'">
            <div class="row q-gutter-md">
              <Input
                name="dashboardName"
                required
                :label="$t('Dashboard name')"
                v-model="dashboardName"
                :error-msg="$t('Please enter the dashboard name.')"
                :description="$t('Please enter within 30 characters.')"
                :placeholder="$t('Dashboard name')"
              />
              <ButtonToggle v-model="buttonToggleValue" :options="buttonToggleOptions" size="md" />
            </div>
            <div class="row" style="float: right">
              <Button
                type="button"
                color="primary"
                :label="$t('Save')"
                size="md"
                @click="onClickSaveBtn"
              />
            </div>
          </template>

          <!-- <template v-if="activeMenuItem === 'Widgets'">
            <div @click="handleAddWidget('chart')" class="cursor-pointer hover-border">
              <Panel :title="$t('Chart Widget')" class="q-mb-md"></Panel>
            </div>
          </template> -->

          <!-- <template v-if="activeMenuItem === 'Delete Dashboard'">
            <p>Are you sure you want to delete this dashboard?</p>
            <Button
              :label="$t('Delete dashboard')"
              color="negative"
              icon="delete"
              @click="onDeleteDashboard"
            />
          </template> -->
        </q-page>
      </q-page-container>
    </q-layout>
  </q-dialog>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { mapGetters, mapActions } from 'vuex';
import Panel from '@design-system/components/Panel';
import ButtonToggle from '@design-system/components/ButtonToggle';
import Button from '@design-system/components/Button';
import Input from '@design-system/components/Input';
const messages = {
  en: {
    Edit: 'Edit',
    Save: 'Save',
    'Dashboard name': 'Dashboard name',
    'Please enter the dashboard name.': 'Please enter the dashboard name.',
    'Please enter within 30 characters.': 'Please enter within 30 characters.',
    Settings: 'Settings',
    Widgets: 'Widgets',
    'RI/SP Widget': 'RI/SP Widget',
  },
  ja: {
    Edit: '更新',
    Save: '保存する',
    'Dashboard name': 'ダッシュボード名',
    'Please enter the dashboard name.': 'ダッシュボード名を入力してください',
    'Please enter within 30 characters.': 'Please enter within 30 characters.',
    Settings: '設定',
    Widgets: 'ウィジェット',
    'RI/SP Widget': 'RI/SP ウィジェット',
  },
};
export default {
  name: 'DialogEditDashboard',
  i18n: { messages: messages },
  components: {
    // ActionCellMenu,
    // Form,
    // FormInput,
    // FormSelector,
    // FormSwitcher,
    // Panel,
    // SimpleTable,
    ButtonToggle,
    Input,
    Panel,
    Button,
  },
  props: {
    visible: {
      type: Boolean,
    },
  },
  watch: {
    currentDashboard() {
      this.dashboardName = this.currentDashboard.name;
      this.buttonToggleValue = this.currentDashboard.isPublic ? 'public' : 'private';
    },
  },
  data() {
    return {
      dashboardName: '',
      drawer: false,
      menuList: [
        {
          label: 'Settings',
          icon: 'o_settings',
          separator: true,
        },
        // {
        //   label: 'Delete Dashboard',
        //   icon: 'delete',
        //   separator: true,
        // },
      ],
      activeMenuItem: 'Settings',
      tableData: [
        {
          user: 'Hajime',
          role: 'owner',
        },
        {
          user: 'Syakir',
          role: 'editor',
        },
        {
          user: 'Ahmed',
          role: 'viewer',
        },
      ],
      columns: [
        {
          name: 'user',
          label: 'User',
          field: 'user',
          align: 'left',
          style: 'min-width: 120px;',
        },
        {
          name: 'role',
          label: this.$t('Role'),
          field: 'role',
          align: 'left',
          style: 'min-width: 350px;',
        },
        { name: 'actionMenu', label: '', required: true },
      ],
      userRoleOptions: [
        { label: this.$t('Owner'), value: 'owner' },
        { label: this.$t('Editor'), value: 'editor' },
        { label: this.$t('Viewer'), value: 'viewer' },
      ],
      buttonToggleValue: 'private',
    };
  },
  computed: {
    ...mapGetters('dashboard', {
      currentDashboardId: 'currentDashboardId',
      currentDashboard: 'currentDashboard',
      layout: 'layout',
    }),

    buttonToggleOptions() {
      return [
        { label: this.$t('Private'), value: 'private' },
        { label: this.$t('Public'), value: 'public' },
      ];
    },

    currentVisible: {
      set(val) {
        this.$emit('update:visible', val);
      },
      get() {
        return this.visible;
      },
    },
  },
  methods: {
    ...mapActions('dashboard', {
      saveDashboard: 'saveDashboard',
      deleteDashboard: 'deleteDashboard',
    }),

    resetEditDialog() {
      this.dashboardName = this.currentDashboard.name;
      this.buttonToggleValue = this.currentDashboard.isPublic ? 'public' : 'private';
      this.activeMenuItem = 'Settings';
    },
    setActiveMenuItem(menuItem) {
      this.activeMenuItem = menuItem;
    },
    handleAddWidget(widget) {
      this.$emit('add-widget', widget);
    },
    onClickSaveBtn() {
      const dashboard = {
        id: this.currentDashboardId,
        name: this.dashboardName,
        isPublic: this.buttonToggleValue === 'public',
        widgets: this.layout.map(item => ({
          widget: item.widget,
          x: item.x,
          y: item.y,
          h: item.h,
          w: item.w,
          i: item.i,
          static: item.static,
          settings: item.settings,
        })),
      };

      this.saveDashboard(dashboard);
      this.currentVisible = false;
    },
    onDeleteDashboard() {
      this.deleteDashboard();
      this.currentVisible = false;
    },
  },
};
</script>

<style lang="scss">
.dialog-edit-dashboard {
  z-index: 999 !important;
}
</style>

<style lang="scss" scoped>
.bg-content {
  background-color: $background;
}
.q-item__section--avatar ::v-deep {
  min-width: auto;
}
.hover-border {
  .q-card {
    border: 2px solid transparent;
  }
  .q-card:hover {
    border: 2px solid $primary;
  }
}
</style>
